import request from '../utils/request.js'
//本周好物推荐
export function recommendGoods(data) {
  return request({
    url: process.env.I_URL + '/api/goods/recommendGoods',
    method: 'get',
  })
}
//搜索商品
export function searchGoods(data) {
  return request({
    url: process.env.I_URL + '/api/goods/searchGoods',
    method: 'post',
    data: data
  })
}
//热搜查询
export function hotSearch(data) {
  return request({
    url: process.env.I_URL + '/api/goods/hotSearch',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/goodsSearch.js